import { render, staticRenderFns } from "./promo-hzmb-detail.vue?vue&type=template&id=07889a14&scoped=true&"
import script from "./promo-hzmb-detail.vue?vue&type=script&lang=js&"
export * from "./promo-hzmb-detail.vue?vue&type=script&lang=js&"
import style0 from "./promo-hzmb-detail.vue?vue&type=style&index=0&id=07889a14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07889a14",
  null
  
)

export default component.exports